var r, o;
function n() {
  if (o) return r;
  o = 1;
  function e() {
  }
  return r = e, r;
}
export {
  n as __require
};
